import React, {useState} from 'react';

function imageHasTransparency(image) {
    if (!image?.naturalWidth || !image?.naturalHeight) {
        return false;
    }

    try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', {willReadFrequently: true});
        if (!context) {
            return false;
        }

        const sampleWidth = Math.min(image.naturalWidth, 256);
        const sampleHeight = Math.min(image.naturalHeight, 256);
        canvas.width = sampleWidth;
        canvas.height = sampleHeight;

        context.drawImage(image, 0, 0, sampleWidth, sampleHeight);
        const {data} = context.getImageData(0, 0, sampleWidth, sampleHeight);

        for (let i = 3; i < data.length; i += 4) {
            if (data[i] < 255) {
                return true;
            }
        }
    } catch {
        return false;
    }

    return false;
}

function ClinicLogoPanel({clinicInfo}) {
    const [hasTransparentBackground, setHasTransparentBackground] = useState(false);

    if (!clinicInfo?.logo) return null;

    const handleLogoLoad = (event) => {
        setHasTransparentBackground(imageHasTransparency(event.currentTarget));
    };

    return (
        <div className="clinic-info-logo-panel">
            <div
                className={`clinic-info-logo-wrap${
                    hasTransparentBackground ? ' clinic-info-logo-wrap--transparent' : ''
                }`}
            >
                <img
                    src={clinicInfo.logo}
                    alt={clinicInfo.name ? `${clinicInfo.name} logo` : 'Clinic logo'}
                    className="clinic-info-logo"
                    onLoad={handleLogoLoad}
                />
            </div>
        </div>
    );
}

export default ClinicLogoPanel;
